import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import { AuthProvider } from "./auth";
import { DialogHost } from "./components/Dialog";
import ImpersonationBanner from "./components/ImpersonationBanner";
import ResumeBanner from "./components/ResumeBanner";
import "./bakeoff.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <App />
      <ResumeBanner />
      <ImpersonationBanner />
      <DialogHost />
    </AuthProvider>
  </StrictMode>,
);
